import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

/* Example of usage:
  {
    GenericDatePicker({
      setDate: this.setPoDate,
      selectedDate: this.state.poDateChosen,
    })
  }
*/

const GenericDatePicker = props => (
  <label htmlFor="dateRange-radio-filter">
    <DateTimePicker
      id={props.id}
      format="MM-DD-YY"
      className="test-rw-input"
      // onChange={(e) => { props.setDate(e); }}
      onCurrentDateChange={(e) => { props.onChange ? console.log("none") : props.setDate(e); }}
      time={false}
      placeholder="Date"
      value={props.selectedDate}
      onBlur={props.onBlur}
      onChange={props.onChange}
    />
  </label>
);

GenericDatePicker.propTypes = {
  id: PropTypes.string,
  setDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
};

GenericDatePicker.defaultProps = {
  id: undefined,
};

export default GenericDatePicker;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/GenericDatePicker.jsx